export const removeAllAccess = (payload: any) => ({
    type: "@saga/DELETE_ALL_ACCESS",
    payload
});